import type { LabelValueProps } from "./LabelValue";

export function getChangeType(value = 0): LabelValueProps["withChange"] {
  if (value > 0) return "positive";
  if (value < 0) return "negative";
  return undefined;
}
